/*************************************************/
/* 3rd Party                                     */
/*************************************************/

// Passive event listeners
document.addEventListener('touchstart', () => { }, { passive: true });
document.addEventListener('touchmove', () => { }, { passive: true });


/*************************************************/
/* Partials                                      */
/*************************************************/

import { intersectionObservation } from "./partials/intersectionObservation.js";
import { header } from "./partials/header.js";
import { language } from "./partials/language.js";
import { menu } from "./partials/menu.js";
import { search } from "./partials/search.js";
import { searchbar } from "./partials/searchbar.js";
import { video } from "./partials/video.js";
import { modal } from "./partials/modal.js";
import { cookies } from "./partials/cookies.js";
import { slider } from "./partials/slider.js";
import { accordion } from "./partials/accordion.js";
import { filter } from "./partials/filter.js";
import { map } from "./partials/map.js";
import { imageAccordion } from "./partials/ImageAccordion.js";
import { employees } from "./partials/employees.js";

/*************************************************/
/* Init                                          */
/*************************************************/

const ready = callback => {
    if (document.readyState != 'loading') callback();
    else document.addEventListener('DOMContentLoaded', callback);
}

ready(() => {

    document.querySelector('#skipLink').addEventListener('click', e => {
        document.querySelector('#mainContent').focus();
    });

    const body = document.querySelector('body');
    const bodyLoadingClass = 'is-loading';

    intersectionObservation();
    header(body);
    language();
    menu();
    search();
    searchbar(body);
    modal(body, bodyLoadingClass);
    video();
    cookies();
    slider();
    accordion();
    filter();
    map();
    imageAccordion();
    employees();
});
